// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"MemberActivation_formGroup__2azEW"};